import { ON_MOVEMENT_READ, ON_MOVEMENT_READING } from '../actions/types';

const INITIAL_STATE = { movements: [], loading: false };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ON_MOVEMENT_READING:
      return { ...state, loading: true };
    case ON_MOVEMENT_READ:
      return { ...state, movements: action.payload, loading: false };
    default:
      return state;
  }
};
